import Select from './Select'
import withField from '../withField'

const SelectField = withField(Select)

export { SelectField }
export default Select
